import { Injectable } from '@angular/core';

import { RolType } from '../shared/models/types/rol.types';
import { AuthService } from '../shared/services/security/auth.service';
import { TranslatorService } from '../shared/services/utils/translator.service';

@Injectable()
export class MenuService {
  rolType: RolType = new RolType();

  constructor(private readonly translationService: TranslatorService,
    private readonly authService: AuthService) { }

  getMenu(): any {
    const menu = [];
    if (this.authService.getUser()) {

      const rolUser = this.authService.getUserRol();

      const listLeadItem = {
        title: this.translationService.trans('menu.leads.title'),
        icon: 'fas fa-users',
        link: '/leads',
        key: 'leads',
        role: 'leads'
      };
      menu.push(listLeadItem);
      
      const quotationsItem = {
        title: this.translationService.trans('menu.quotations.title'),
        icon: 'fas fa-file-invoice',
        link: '/quotations',
        key: 'quotations',
        role: 'quotations'
      };
      menu.push(quotationsItem);

      const planningItem = {
        title: this.translationService.trans('menu.planning_of_day.title'),
        icon: 'far fa-calendar',
        link: '/planning',
        pathMatch: 'full',
        key: 'planning',
        home: false,
      };
      menu.push(planningItem);

      // const metricSales = {
      //   title: this.translationService.trans('menu.metrics.sales.title'),
      //   icon: 'fas fa-chart-pie',
      //   link: '/metrics/sales',
      //   key: 'metrics.sales'
      // };
      // menu.push(metricSales);

      // const metricsMarketing = {
      //   title: this.translationService.trans('menu.metrics.marketing.title'),
      //   icon: 'far fa-chart-bar',
      //   link: '/metrics/marketing',
      //   key: 'metrics.marketing'

      // };
      // menu.push(metricsMarketing);

      const analytics = {
        title: this.translationService.trans('menu.analytics.title'),
        icon: 'fas fa-chart-line',
        link: '/analytics',
        key: 'analytics',
      };
      menu.push(analytics);

      if (rolUser === this.rolType.ROLE_ADMIN || rolUser === this.rolType.ROLE_SUPERADMIN) {
        const itemDashboardV2 = {
          title: this.translationService.trans('menu.dashboard'),
          icon: 'dapa-icon-dashboard',
          link: '/v2/dashboard',
          key: '/v2/dashboard',
          role: '/v2/dashboard',
          home: false
        };
        menu.push(itemDashboardV2);
      }

      // if (rolUser !== this.rolType.ROLE_USER) {
      //   const itemMenuReporting = {
      //     title: this.translationService.trans('menu.reporting.title'),
      //     icon: 'fas fa-file-excel',
      //     link: '/reporting',
      //     key: 'reporting',
      //     home: false,
      //   };
      //   menu.push(itemMenuReporting);
      // }

      // const itemMenuCalendar = {
      //   title: this.translationService.trans('menu.calendar'),
      //   icon: 'far fa-calendar-alt',
      //   link: '/calendar',
      //   key: 'calendar',
      //   home: false,
      // };
      // menu.push(itemMenuCalendar);

      if (rolUser === this.rolType.ROLE_SUPERADMIN || rolUser === this.rolType.ROLE_ADMIN) {

        const itemMenuInvestment = {
          title: this.translationService.trans('menu.investment'),
          icon: 'fas fa-euro-sign',
          link: '/investment',
          key: 'investment',
          role: 'investment',
          home: false
        };
        menu.push(itemMenuInvestment);
      }

      // const profileItem = {
      //   title: this.translationService.trans('auth.profile'),
      //   icon: 'fas fa-user',
      //   link: '/profile',
      //   pathMatch: 'full',
      //   key: 'profile',
      //   home: false,
      // };
      // menu.push(profileItem);

      if (rolUser !== this.rolType.ROLE_USER && rolUser !== this.rolType.ROLE_BDC) {
        const profileCompanyItem = {
          title: this.translationService.trans('menu.configuration'),
          icon: 'fas fa-cogs',
          link: '/profile/company',
          pathMatch: 'full',
          key: 'company',
          home: false,
        };
        menu.push(profileCompanyItem);
      }

      // const itemMenuSupport = {
      //   title: this.translationService.trans('chat.support'),
      //   icon: 'fas fa-comments',
      //   skipLocationChange: true,
      //   key: 'chat_toggle',
      //   home: false
      // };
      // menu.push(itemMenuSupport);

      if (rolUser === this.rolType.ROLE_SUPERADMIN || rolUser === this.rolType.ROLE_ADMIN) {
        const itemMenuDashBoard = {
          title: this.translationService.trans('menu.home'),
          icon: 'fas fa-pager',
          link: '/dashboard',
          key: 'dashboard',
          role: 'dashboard',
          home: false
        };
        menu.unshift(itemMenuDashBoard);
      }

      // if (rolUser === this.rolType.ROLE_BDC) {
      //   const itemMenuDashBoardBdc = {
      //     title: this.translationService.trans('menu.dashboard'),
      //     icon: 'fas fa-headset',
      //     link: '/dashboard-bdc',
      //     key: 'dashboard-bdc',
      //     role: 'dashboard-bdc',
      //     home: false
      //   };
      //   menu.unshift(itemMenuDashBoardBdc);
      // }

      // if (rolUser === this.rolType.ROLE_USER) {
      //   const itemMenuDashBoardBdc = {
      //     title: this.translationService.trans('menu.dashboard'),
      //     icon: 'fas fa-pager',
      //     link: '/dashboard-bdc',
      //     key: 'dashboard-bdc',
      //     role: 'dashboard-bdc',
      //     home: false
      //   };
      //   menu.unshift(itemMenuDashBoardBdc);
      // }

      if (rolUser === this.rolType.ROLE_DAPDA) {
        const itemDapda = {
          title: this.translationService.trans('menu.admin'),
          icon: 'dapa-icon-leadin',
          link: '/admin',
          key: 'dapda',
          role: 'dapda',
          home: false
        };
        menu.push(itemDapda);
      }
    }

    return menu;
  }
}
